module.exports = __webpack_public_path__ + "img/ratesIcon.11186dec.svg";